<template>
	<div>
		<h3 v-if="day !== null">{{dateName}} <span>{{day}}</span></h3>
		<div v-if="index % 5 === 0 && index !== 0">
			<InFeedAdsense
				data-ad-layout-key="-fg+5t+6e-gc+67"
				data-ad-client="ca-pub-8746296356969794"
				data-ad-slot="2388712700"
				:data-ad-test="this.$store.getters.debug ? 'on' : 'off'"
				>
			</InFeedAdsense>
		</div>
		<article>
			<div class="program__poster" :style="poster"></div>
			<div class="program__detail" :style="cinemaLogo">
				<h4><span class="cinema">Kino Svetozor:</span><span class="time">{{time}}:</span> {{projection.movie.title}}</h4>
				<ul>
					<li v-if="projection.language">{{projection.language}}</li>
					<li v-if="projection.price || projection.movie.year">
						<span v-if="projection.movie.year">{{projection.movie.year}}<span v-if="projection.price">, </span></span>
						<span v-if="projection.price">{{projection.price}} Kč</span>
					</li>
					<li>
						<span class="rating-1" v-if="projection.imdb_rating">IMDB: {{projection.imdb_rating}}</span>
						<span class="rating-2" v-if="projection.csfd_rating">ČSFD: {{projection.csfd_rating}}</span>
					</li>
				</ul>
			</div>
		</article>
	</div>
</template>

<script>
import * as moment from 'moment'
import helpers from '../../libs/helpers'

export default {
	name: 'program-item',
	props: ['projection', 'index'],
	data () {
		return {
			day: null
		}
	},
	computed: {
		/**
		 * Get the movie poster
		 */
		poster: function () {
			let image = false
			if (this.projection.movie.image) {
				if (this.projection.movie.image.indexOf('http') !== -1) {
					image = btoa(unescape(encodeURIComponent(this.projection.movie.image)))
				} else {
					image = this.projection.movie.image
				}
			}
			return image
						? `background-image: url("https://www.artkina.cz/api/1.2/image/200/200/${image}/"); background-size: cover;`
						: ''
		},

		/**
		 * Get the projection time
		 */
		time: function () {
			return moment(this.projection.date.date).format('HH:mm')
		},

		dateName: function () {
			return helpers.nameTheDate(this.day)
		},

		cinemaLogo: function () {
			const cinema = this.$store.getters.selectedCinemas(this.projection.cinema_id)
			return `background-image: url(https://www.artkina.cz/img/kino-${cinema.slug}.png);`
		}
	},
	created: function () {
		const formatedDate = moment(this.projection.date.date).format('DD.MM.YYYY')
		if (this.$store.state.programDateHeader !== formatedDate) {
			this.$store.commit('programDateHeader', formatedDate)
			this.day = formatedDate
		} else {
			this.day = null
		}
	}
}
</script>

<style lang=less scoped>
	@import "../../assets/less/default.less";

	article { display: flex; min-height: 110px; margin-bottom: 0.5ex; color: @grey; -webkit-mask-box-image: url(../../assets/images/sprites/stamp.svg) 5 repeat; mask-border: url("../../assets/images/sprites/stamp.svg") 5 repeat; .bgc(#fff); cursor: pointer;
		.program__poster { width: 40%; min-width: 40%; background: @redDark url('../../assets/images/sprites/logo.png') 70% 50% no-repeat; }
		.program__detail { padding: 1ex 1em; flex-grow: 1; background-position: 100% 100%; background-repeat: no-repeat; background-size: 40%;
			h4 { width: 100%; font-size: 24/15rem;
				span.cinema { display: none; }
				span.time { color: @red; }
			}
		}
		transition: all .2s ease-in;
	}
</style>



// WEBPACK FOOTER //
// src/components/program/ProgramItem.vue